import React, { createElement } from 'react';
import { LIGHT_TYPE } from '@yme/tokens/colorSchema';
import { buildRandomValue } from '@yme/utils/common';
import { CheckboxInput } from './CheckboxInput';
import { DEFAULT_PROPS } from './constants';
import { CheckboxStyled, CheckboxStyledWrapper, LabelStyled, PlaceholderStyled } from './styled';
export function Checkbox(props) {
    const { onClick, onChange, value, id, label, minHeight, valueWrapper = null, isRightToLeft = false, theme = LIGHT_TYPE, descriptionText = '', optionalText = '', className, disabled = false, defaultChecked, required, checked, hasMultipleChecked, } = props;
    const uniqueId = buildRandomValue();
    const checkBoxProps = {
        ...DEFAULT_PROPS,
        defaultChecked,
        disabled,
        required,
        checked,
        hasMultipleChecked,
        isRightToLeft,
        id: id || value || uniqueId,
        onClick,
        onChange,
        theme,
        value,
    };
    return (React.createElement(CheckboxStyledWrapper, { className: className, isRightToLeft: isRightToLeft, minHeight: minHeight, onClick: onClick },
        React.createElement(CheckboxStyled, null,
            React.createElement(CheckboxInput, { ...checkBoxProps }),
            React.createElement(LabelStyled, { htmlFor: id || value || uniqueId, isRightToLeft: isRightToLeft, theme: theme, hasLabelIndent: !!value },
                React.createElement("span", null, label ? label : valueWrapper ? createElement(valueWrapper, {}, value) : value),
                optionalText && React.createElement("span", null, optionalText))),
        descriptionText && (React.createElement(PlaceholderStyled, { isRightToLeft: isRightToLeft }, descriptionText))));
}
Checkbox.displayName = 'Checkbox_Component';
